<div class="contarine-fluid mt-2">
	<div class="row g-1">
		<div class="col-12">
			<div class="card">
				<div class="card-body">
					@if((queue | async)!.length>0){
					<p class="float-end badge bg-primary">
						Queue length:
						{{ (queue | async)!.length }}
					</p>
					}
					<h4 class="my-0 fw-bold">
						Files
					</h4>
					@if ((queue | async)!.length>0) {
					<table class="table table-bordered table-hover">
						<thead>
							<tr>
								<th>Name</th>
								<th class="text-end">Size</th>
								<th class="text-end">Progress</th>
								<th>Status</th>
								<th>Preview</th>
								<th class="text-end">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let item of queue | async">
								<td>
									<p class="mb-0">
										{{ item?.file?.name }}
									</p>
								</td>
								<td class="text-end">
									{{ item?.file?.size/1024/1024 | number:'.2' }} MB
								</td>
								<td class="text-end">{{ item.progress + ' %' }}</td>
								<td>
									@if (item.isPending()) {
									<span class="badge bg-default"></span>
									}
									@if (item.isSuccess()) {
									<span class="badge bg-success">
										Uploaded
									</span>
									}
									@if (item.inProgress()) {
									<span class="badge bg-warning">
										Uploading
									</span>
									}
									@if (item.isError()) {
									<span class="badge bg-danger">
										Failed
									</span>
									}
								</td>
								<td>
									@if (item.uploaded_url) {
									<a href="{{File_Storage_URL}}{{item.uploaded_url}}" target="_blank"
										matTooltip="Click to view">
										<img [src]="isImage(item?.file?.name)?File_Storage_URL+item.uploaded_url:defaultIcon"
											class="attachment-thumb me-2" />
									</a>
									}
								</td>
								<td class="text-end">
									@if (item.isUploadable()) {
									<button type="button" class="btn btn-xs btn-primary me-1" matTooltip="Upload file"
										(click)="item.upload()">
										<fa-icon [icon]="['fas', 'cloud-upload-alt']"></fa-icon>
									</button>
									}
									@if (item.inProgress()) {
									<button type="button" class="btn btn-xs btn-warning me-1" matTooltip="Cancel upload"
										(click)="item.cancel()">
										<fa-icon [icon]="['fas', 'times-circle']"></fa-icon>
									</button>
									}
									@if (!item.inProgress()) {
									<button type="button" class="btn btn-xs btn-danger me-1"
										matTooltip="Remove from queue" (click)="item.remove()">
										<fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
									</button>
									}
								</td>
							</tr>
						</tbody>
					</table>
					}
					<button type="button" class="btn btn-xs btn-info" (click)="fileInput.click()">
						@if(fetchingPresignedURL){
						<fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'"></fa-icon>
						}@else{
						<fa-icon [icon]="['fas', 'cloud-upload-alt']"></fa-icon>
						}
						Add Files
						<input type="file" #fileInput multiple (change)="addToQueue()" class="d-none" />
					</button>
					@if ((queue | async)!.length){
					<button type="button" class="btn btn-xs btn-danger ms-1" (click)="uploader.clearQueue()">
						Clear queue
					</button>
					}
					<button type="button" class="btn btn-xs btn-primary ms-1" (click)="uploader.uploadAll()"
						[disabled]="(queue | async)!.length==0 || fetchingPresignedURL">
						<fa-icon [icon]="['fas', 'cloud-upload-alt']"></fa-icon>
						Upload
					</button>
					@if ((queue | async)!.length) {
					<p class="mb-0 text-success fw-bold">
						Please click on upload button after adding all files.
					</p>
					}
				</div>
			</div>
		</div>
	</div>
</div>